<!-- 验证码组件 -->
<template>
  <div class="vertify-position">
    <!-- 如果方法中写了默认参数，则需要在这里调用方法时带上()，否则默认参数会变成点击事件的参数 -->
    <canvas ref="canvas" @click="createCode()"></canvas>
  </div>
</template>

<script>
export default {
  props: {
    customStyle: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      checkCode: "",
      cvs: null,
      ctx: null,
      str: '0123456789abcdefghijklmnopqrstuvwxyz'
    };
  },
  mounted() {
    this.cvs = this.$refs.canvas
    this.ctx = this.cvs.getContext('2d')
    this.init()
  },
  methods: {
    init() {
      this.cvs.width = 100 * devicePixelRatio
      this.cvs.height = 40 * devicePixelRatio

      this.createCode();
    },
    createCode(count = 4, fontSize = 18) {
      // 先清空验证码的输入
      this.checkCode = "";
      // 清空画布,达到刷新重画功能
      this.ctx.fillStyle = '#555';
      this.ctx.fillRect(0, 0, this.cvs.width, this.cvs.height)
      fontSize = fontSize * devicePixelRatio
      this.ctx.font = fontSize + 'px Monaco'
      this.ctx.fillStyle = '#fff';
      this.ctx.textAlign = 'center'
      this.ctx.textBaseline = 'top'
      const padding = 10
      const width = this.cvs.width - 2 * padding

      for (let i = 0; i < count; i++) {
        const text = this.getRandomChar().toUpperCase(),
          x = width / count * (i + 1)

        this.checkCode += text
        this.ctx.fillText(text, x, 14)
      }
      this.$emit("getRealCode", this.checkCode);
    },

    getRandomChar() {
      return this.str[Math.floor(Math.random() * this.str.length)]
    }
  },
};
</script>
<style lang="less" scoped>
.vertify-position {
  width: 100px;
  height: 40px;
  line-height: 40px;

  canvas {
    width: 100%;
    height: 100%;
    border: 1px solid rgba(238, 238, 238, 0.411);
    cursor: pointer;
  }
}

::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #ddd;
}
</style>